import { useContext } from 'react';

import FeatureFlagsContext from 'contexts/FeatureFlagsContext';

export const useFeatureFlags = () => useContext(FeatureFlagsContext);
